import * as React from 'react';

import { OptionsViewModel } from '@models/common.models';
import { CoverageOption } from '@models/CoverageOption';

import {
  ProductViewModel,
  PriceAdjustmentViewModel,
  ProductGroupViewModel,
  ProductChannelViewModel,
  EmployeeDiscountViewModel
} from '@models/Product';
import {
  ProductNCoveragesComponent,
  ProductNCoveragesComponentPropertiesAttributes,
  CoverageForm
} from './product-n-coverages.component';
import { CoverageOptionSelectComponent } from './coverage-options-select.component';
import { CoverageCalcuationComponent, CoverageCalcuationComponentProperties } from './coverage-calculation.component';
import { ViewSelectedCoveragesComponent } from './view-selected-coverages.componet';
import { ContractOrderType } from '@models/Contract';

export interface CoverageProperties {
  readonly productAndCoverageOptions: ProductNCoveragesComponentPropertiesAttributes;
  readonly coverageOptions: Array<CoverageOption>;
  readonly selectedCoverageOptions: Array<CoverageOption>;
  readonly calculationModel: CoverageCalcuationComponentProperties;
  readonly currentStep: number;
  readonly selectedProduct: ProductViewModel;
  readonly sellerCoverage: boolean;
  readonly isOrderEdit?: boolean;
  readonly isOpenContract?: boolean;

  readonly onMount: () => void;
  readonly removeSellersCoverage: () => void;
  readonly selectProductGroup: (productGroup: ProductGroupViewModel) => void;
  readonly selectProductChannel: (productChannel: ProductChannelViewModel) => void;
  readonly selectProduct: (product: OptionsViewModel, group: number) => void;
  readonly selectEmployeeDiscount: (employeeDiscount: EmployeeDiscountViewModel) => void;
  readonly toggleCoverageOption: (option: CoverageOption) => void;
  readonly selectPriceAdjustment: (adjustment: PriceAdjustmentViewModel) => void;
  readonly toggleSellersCoverage: () => void;
  readonly setPriceAdjustmentAmount: (amount: number) => void;
  readonly onSaveClick: (model: CoverageForm) => void;
  readonly onLeave: () => void;
}

const SELLER_HVAC = 'Seller HVAC';
export class CoverageComponent extends React.Component<CoverageProperties> {
  constructor(props: CoverageProperties) {
    super(props);
  }

  componentDidMount() {
    this.props.onMount();
  }

  componentWillUnmount() {
    this.props.onLeave();
  }

  componentWillReceiveProps(nextProps: CoverageProperties) {
    if (
      nextProps.productAndCoverageOptions.orderType === ContractOrderType.DTC &&
      nextProps.productAndCoverageOptions.orderType !== this.props.productAndCoverageOptions.orderType
    ) {
      this.props.removeSellersCoverage();
    }
  }

  render() {
    return (
      <div className="form-horizontal">
        <div className="row">
          <div className="col-md-12">
            <h2>Step {(this.props.currentStep + 1).toString()}: Coverage</h2>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-6 col-md-3 col-lg-4">
            <ProductNCoveragesComponent
              {...this.props.productAndCoverageOptions}
              selectEmployeeDiscount={this.props.selectEmployeeDiscount}
              onSaveClick={this.props.onSaveClick}
              toggleSellersCoverage={this.props.toggleSellersCoverage}
              selectProductGroup={this.props.selectProductGroup}
              selectProduct={this.props.selectProduct}
              isOrderEdit={this.props.isOrderEdit}
              isOpenContract={this.props.isOpenContract}
            />
          </div>
          <div className="col-xs-12 col-md-5 col-lg-4">
            <CoverageOptionSelectComponent
              coverageOptions={this.props.coverageOptions.filter(option => !option.isBasicCoverage)}
              selectedCoverageOptions={this.props.selectedCoverageOptions}
              toggleCoverageItem={this.props.toggleCoverageOption}
              isOpenContract={this.props.isOpenContract}
              isOrderEdit={this.props.isOrderEdit}
            />
          </div>
          <div className="col-xs-12 col-md-3 col-lg-4">
            <ViewSelectedCoveragesComponent
              product={this.props.selectedProduct}
              coverageOptions={this.props.selectedCoverageOptions}
              hasSellersCoverage={this.props.sellerCoverage}
            />
            <CoverageCalcuationComponent {...this.props.calculationModel} />
          </div>
        </div>
        <div className="col-xs-12 col-md-7 col-lg-8">
          {this.props.coverageOptions.filter(option => option.value === SELLER_HVAC).length ? (
            <h2>Please be sure to ask the customer if they'd like to add HVAC coverage</h2>
          ) : (
            ''
          )}
        </div>
        <div className="row end-xs">
          <div className="col-md">
            <button hidden={true} className="btn btn-primary" type="submit">
              Continue
            </button>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/contract/_components/coverage/_components/coverage.component.tsx